import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addProviders, changeProvider } from '../../../actions/providers';
import ProviderInfoApi from '../../../API/provider/providerInfo-api';
import pencil from '../../../assets/media/icon_pencil.svg';
import { Row } from '../../../components/Basic/Blocks';
import { Button, CheckButton } from '../../../components/Basic/Buttons';
import { Icon } from '../../../components/Basic/Elements';
import { Content } from '../../../components/Basic/Global';
import { Input } from '../../../components/Basic/Inputs';
import { HeaderTitle, Table, TableCell, TableHeader, TableLine } from '../../../components/Basic/Table';
import { TYPE_BUTTONS } from '../../../constans';
import CreateProviderPopUp from './CreateProviderPopUp';
import EditProvider from './EditProvider';

const width = ['150px', '150px', '70px', '150px', '100px', '90px'];

function ProvidersPage() {
  const dispatch = useDispatch();

  const [showNew, setNew] = useState(false);
  const [showEdit, setEdit] = useState({ show: false, data: null });
  const providers = useSelector((store) => store.providers);

  const updateProvider = async (provider, key, valye) => {
    await ProviderInfoApi.changeProvider({ data: { providerId: provider.id, data: { [key]: valye } } })
      .then((r) => dispatch(changeProvider(provider.id, r.provider)))
  };

  useEffect(() => {
    ProviderInfoApi.getAll({}).then(r => dispatch(addProviders(r.providers)))
  }, []);

  return (
    <>
      <Content>
        <Row style={{ marginBottom: '20px' }} spaceBetween={true}>
          <Button type={TYPE_BUTTONS.BLUE} onClick={() => setNew(true)}>
            Добавить нового поставщика
          </Button>
        </Row>
        <Table whiteTable={true} style={{ width: 'auto' }}>
          <TableHeader whiteHeader={true}>
            <HeaderTitle width={width[0]}>ID</HeaderTitle>
            <HeaderTitle width={width[1]}>Имя</HeaderTitle>
            <HeaderTitle width={width[0]}>Префикс</HeaderTitle>
            <HeaderTitle width={width[1]} centerText>
              Дней для просталения расхождения
            </HeaderTitle>
            <HeaderTitle width={width[1]} centerText>
              Дней для оформления расхождения
            </HeaderTitle>
            <HeaderTitle width={width[2]} centerText>
              Курс $
            </HeaderTitle>
            <HeaderTitle width={width[5]} centerText>
              Мелкий поставщик
            </HeaderTitle>
            <HeaderTitle width={width[5]} centerText>
              Склад Мск
            </HeaderTitle>
            <HeaderTitle width={width[5]} centerText>
              Склад Екб
            </HeaderTitle>
            <HeaderTitle width={width[1]} centerText>
              Редактировать / Скрыть
            </HeaderTitle>
            <HeaderTitle width={width[1]} centerText>
              Скрыть в обновлении
            </HeaderTitle>
          </TableHeader>
          {providers.map((item, key) => (
            <TableLine key={key}>
              <TableCell width={width[0]}>(id: {item.id})</TableCell>
              <TableCell width={width[1]}>{item.name}</TableCell>
              <TableCell width={width[0]}>{item.prefix}</TableCell>
              <TableCell width={width[1]} center>
                <Input
                  value={item.discrepancies_limits?.shipment}
                  onBlur={(v) =>
                    updateProvider(item, 'discrepancies_limits', {
                      'discrepancies_limits.shipment': parseInt(v),
                    })
                  }
                  center
                />
              </TableCell>

              <TableCell width={width[1]} center>
                <Input
                  value={item.discrepancies_limits?.common}
                  onBlur={(v) =>
                    updateProvider(item, 'discrepancies_limits', { 'discrepancies_limits.common': parseInt(v) })
                  }
                  center
                />
              </TableCell>

              <TableCell width={width[2]} center={true}>
                {item.course}
              </TableCell>

              <TableCell width={width[5]} center>
                <CheckButton checked={item.is_stock} onSelect={(v) => updateProvider(item, 'is_stock', v)} />
              </TableCell>
              <TableCell width={width[5]} center>
                <CheckButton checked={item.sklads?.msk} onSelect={(v) => updateProvider(item, 'msk', v)} />
              </TableCell>
              <TableCell width={width[5]} center>
                <CheckButton checked={item.sklads?.ekb} onSelect={(v) => updateProvider(item, 'ekb', v)} />
              </TableCell>
              <TableCell width={width[1]} center>
                <Button onClick={() => setEdit({ show: true, data: item })}>
                  <Icon src={pencil} width="18px" style={{ marginRight: '15px' }} />
                </Button>
                <CheckButton checked={item.hide} onSelect={(v) => updateProvider(item, 'hide', v)} />
              </TableCell>
              <TableCell width={width[1]} center>
                <CheckButton checked={item.hide_update} onSelect={(v) => updateProvider(item, 'hide_update', v)} />
              </TableCell>
            </TableLine>
          ))}
        </Table>
        {showNew && <CreateProviderPopUp close={() => setNew(false)} />}
        {showEdit.show && <EditProvider provider={showEdit.data} close={() => setEdit({ show: false, data: null })} />}
      </Content>
    </>
  );
}

export default ProvidersPage;
